import { render } from "./ModalSide.vue?vue&type=template&id=0eb186cb"
import script from "./ModalSide.vue?vue&type=script&lang=js"
export * from "./ModalSide.vue?vue&type=script&lang=js"

import "./ModalSide.vue?vue&type=style&index=0&id=0eb186cb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__